module.exports = __webpack_public_path__ + "tn.svg?363af3220590457503a251a85a59464c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/tn.svg
// module id = 1398
// module chunks = 27